// src/controllers/impuestoPlantillaController.js

import { getImpuestoPlantillas, createImpuestoPlantilla, updateImpuestoPlantilla, deleteImpuestoPlantilla } from '../models/impuestoPlantillaModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

// Obtener las plantillas de impuestos
export async function fetchImpuestoPlantillas(page, perPage) {
  try {
    const response = await getImpuestoPlantillas(page, perPage);
    return {
      impuesto_plantilla: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching impuesto plantillas:", error);
    Swal.fire('Error', 'No se pudieron cargar las plantillas de impuestos', 'error');
    return null;
  }
}

// Guardar una nueva plantilla de impuesto o actualizar una existente
export async function saveImpuestoPlantilla(impuestoPlantilla, currentImpuestoPlantillaId) {
  try {
    if (currentImpuestoPlantillaId) {
      await updateImpuestoPlantilla(currentImpuestoPlantillaId, impuestoPlantilla);
      toasts.add({
        title: 'Éxito',
        description: 'Plantilla de impuesto actualizada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createImpuestoPlantilla(impuestoPlantilla);
      toasts.add({
        title: 'Éxito',
        description: 'Plantilla de impuesto creada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving impuesto plantilla:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la plantilla de impuesto',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

// Eliminar una plantilla de impuesto
export async function removeImpuestoPlantilla(id) {
  try {
    await deleteImpuestoPlantilla(id);
    toasts.add({
      title: 'Éxito',
      description: 'Plantilla de impuesto eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting impuesto plantilla:", error);
    Swal.fire('Error', 'No se pudo eliminar la plantilla de impuesto', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'impuesto_plantilla'
export function subscribeToImpuestoPlantillas(searchQuery, handleSearch) {
  pb.collection('impuesto_plantilla').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromImpuestoPlantillas() {
  pb.collection('impuesto_plantilla').unsubscribe('*');
}

// Búsqueda de plantillas de impuestos
export async function searchImpuestoPlantillas(query, page = 1, perPage = 10) {
  const response = await pb.collection('impuesto_plantilla').getList(page, perPage, {
    filter: `descrip ~ "${query}"`,
  });
  return {
    impuesto_plantilla: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}